export const HEADER_LOGGED_IN_HEIGHT = 50;
export const HEADER_LOGGED_OUT_HEIGHT = 72;
export const STICKY_TOP_CLASS = 'top-[50px]';
